
import { mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  props: {
    cartItem: {
      default: () => {},
      type: Object
    },
    isCartPage: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      selectedChoices: [],
      selectedAddons: []
    };
  },
  computed: {
    ...mapState("menu", ["addons"]),
    variantName() {
      const variant = this.cartItem.variants?.items.find(
        (variant) => variant.id === this.cartItem.variantId
      );
      return variant ? ` ${variant.name}` : "";
    },

    choiceNames() {
      const choiceItems = this.cartItem.item_groups?.items || [];
      const flattenedChoices = choiceItems.flatMap(
        (group) => group.choices || []
      );
      const selectedChoices = [];

      this.cartItem.choiceIds?.forEach((choiceIdObj) => {
        flattenedChoices.forEach((choice) => {
          if (choiceIdObj?.selectedIds?.includes(choice.id)) {
            selectedChoices.push(choice.name);
          }
        });
      });

      if (selectedChoices.length === 0) {
        return "";
      } else if (selectedChoices.length === 1) {
        return ` ${selectedChoices[0]} choice`;
      } else {
        const allButLast = selectedChoices.slice(0, -1).join(", ");
        const last = selectedChoices[selectedChoices.length - 1];
        return ` ${allButLast} and ${last} choices`;
      }
    },

    addonNames() {
      const selectedAddonIds = new Set(
        this.cartItem.addonIds?.flatMap(
          (addonIdObj) => addonIdObj.selectedIds
        ) || []
      );

      const addonGroups = this.cartItem.item_addons?.items || [];
      const allAddons = addonGroups.flatMap((group) => group.addons || []);

      const selectedAddons = Array.from(
        new Set(
          allAddons
            .filter((addon) => selectedAddonIds.has(addon.id))
            .map((addon) => addon.item_name)
        )
      );

      if (selectedAddons.length === 0) return "";

      if (selectedAddons.length === 1) {
        return ` ${selectedAddons[0]} addon`;
      }

      return ` ${selectedAddons.slice(0, -1).join(", ")}, and ${
        selectedAddons[selectedAddons.length - 1]
      } addons`;
    },
    customizationSummary() {
      const variantText = this.variantName ? `${this.variantName}` : "";
      const choiceText = this.choiceNames ? ` ${this.choiceNames}` : "";
      const addonText = this.addonNames ? ` ${this.addonNames}` : "";
      return ` ${[variantText, choiceText, addonText]
        .filter(Boolean)
        .join("-")}`;
    }
  },
  methods: {}
};
